import { useState } from 'react';
import '@src/styles/components/customCollapseCardNew.scss';
import { Collapse } from 'antd';
import { CustomImage } from './index';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import iconDown from '@src/assets/icons/icon-down.svg';
import iconUp from '@src/assets/icons/icon-up.svg';

import { Text } from '@src/components';

const { Panel } = Collapse;

function getExpandIcon(setActiveCollapse, switchIcon) {
  return ({ isActive }) => {
    setActiveCollapse(isActive);
    return (
      <div style={{ border: '2px solid #586377', borderRadius: '24px' }}>
        {isActive ? (
          <CustomImage className="open-close" src={!switchIcon ? iconUp : iconDown} />
        ) : (
          <CustomImage className="open-close" src={!switchIcon ? iconDown : iconUp} />
        )}
      </div>
    );
  };
}

const CustomCollapseCardNew = ({
  children,
  cardTitleAlign,
  bodyCenter,
  className,
  switchIcon = false,
  orderNumber,
  orderType,
  orderAmount,
  orderDate,
  orderStatus,
}) => {
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });

  const [activeCollapse, setActiveCollapse] = useState(false);
  return (
    <Collapse
      className={`${className || ''} ${activeCollapse ? 'active' : ''}`}
      ghost
      expandIconPosition="right"
      expandIcon={getExpandIcon(setActiveCollapse, switchIcon)}
    >
      <Panel
        header={
          <div
            style={{
              textAlign: isMobil ? 'left' : cardTitleAlign || 'left',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: isMobil ? '100% !important' : 'auto !important',
            }}
          >
            <div>
              <p>
                <Text t="orderNo" />
              </p>
              <span>{orderNumber}</span>
            </div>
            {!isMobil ? (
              <div>
                <p>
                  <Text t="orderType" />
                </p>
                <span>{orderType}</span>
              </div>
            ) : null}
            {!isMobil ? (
              <div>
                <p>
                  <Text t="orderAmount2" />
                </p>
                <span>{orderAmount} TL</span>
              </div>
            ) : null}
            {!isMobil ? (
              <div>
                <p>
                  <Text t="orderDate2" />
                </p>
                <span>{orderDate}</span>
              </div>
            ) : null}
            <div className="mobil">
              <p
                style={{
                  color:
                    orderStatus === 'Krediler Üretildi' || orderStatus === 'Teslim Edildi'
                      ? '#00a483'
                      : '#f14c08',
                  fontFamily: 'UbuntuBold',
                }}
              >
                {orderStatus}
              </p>
            </div>
          </div>
        }
        key="1"
      >
        <div className={bodyCenter ? 'd-flex justify-content-center' : ''}>{children}</div>
      </Panel>
    </Collapse>
  );
};

export default CustomCollapseCardNew;
